module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA4ElEQVQ4ja2SW3LEIAwEW6k9mG6GuJk42eSDx2Lj3Z9EVS4D1rRGRvDHMEmPH2qtAiil2FeCpOOJiLGUIkJ9f+ZJOgEjWRGhzFQPPoIexas6KGADnY4OMaDe2TuuoGtrl57fwr7eBQu0XI5ie+VJzUzt53tb9wIvgNYaEpgFABGBuwOGJGqtRMC8cbOek5n9JjNz/ajdNhfLPW+ezfUPQGaSmbTWxhDFmBFwd2qtgHD35c7dkWQmCTPTtA5dNO2VUoZtO8THKD+B5vtJDPC6jbU9gSbkLj4c3GOC7gX+NX4BM9ycUEesdPgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/INETNEWS.png
// module id = 82
// module chunks = 0